import { Link } from 'react-router-dom'
import { FaInstagram } from "react-icons/fa";
const Instagram = () => {
   return (
      <>
         <Link to={"https://www.instagram.com/latitudsur.arg"} target="_blank" className="instagram-float pulse" title="Instagram">
            <FaInstagram />
         </Link>
      </>
   )
}

export default Instagram